import * as React from 'react';
import { WithStyles, withStyles } from '@material-ui/core';
import classnames from 'classnames';

import styles from './SkeletonBox.styles';

export type SkeletonBoxProps = {
  width?: number | string;
  height?: number | string;
  display?: string;
  className?: string;
};

type Props = SkeletonBoxProps & WithStyles<typeof styles>;

const SkeletonBox: React.FunctionComponent<Props> = (props) => {
  const { classes, children, className, height, width, display = 'auto' } = props;

  const classNames = classnames(classes.content, className);

  return (
    <div className={classNames} style={{ width, height, display }}>
      {children}
    </div>
  );
};

export default withStyles(styles)(SkeletonBox);
